import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "input-wrap"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li", null, " 1. 请准确维护供应商类别, 当供应商类别选择为\"生产厂家\"或\"商贸公司\"时, 您必须关联ERP供应商。 "), /*#__PURE__*/_createElementVNode("li", null, " 2.\"生产厂家\"或\"商贸公司关联ERP供应商后, 您可通过\"可售药品\"维护模块开启品种自动新增, 无需特殊维护。 ")], -1);

const _hoisted_3 = /*#__PURE__*/_createTextVNode("否");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("是");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("指定厂家");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("指定发货方");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#f56c6c",
    "margin-left": "8px",
    "display": "inline-block",
    "vertical-align": "middle"
  }
}, "关联项目调整请通知发货方至万药城调整", -1);

const _hoisted_9 = {
  key: 0
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存");

import { ref, computed, watch, nextTick } from 'vue';
import { getCatalog, mergeSupplier, getEditDistributorList } from '@/request';
import { arrayRemoveRepeatByProp } from '@/utils';
import { ElMessage, ElMessageBox, ElLoading } from 'element-plus';
import SelectDistributorListModal from './SelectDistributorListModal.vue';
export default {
  name: 'AddControlSalesTeamModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    editData: {
      type: [null, Object],
      default: null
    },
    dictList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success', 'loadSuccess'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const formRef = ref();
    const showDistributorListModal = ref(false);
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const teamTypes = ref([]);
    const tableData = ref([]);
    const table = ref();
    const scroll = ref();
    const projectOptions = ref([]);
    const allProjects = ref([]);
    const form = ref({
      branchIds: '',
      inputBusiScop: [],
      supplierName: '',
      supplierCategory: 2,
      linkMan: '',
      linkPhone2: '',
      changeSalemansBranch: '0',
      areaLevel: ''
    });
    const areaLevels = [{
      label: '全国团队',
      value: 'country'
    }, {
      label: '大区团队',
      value: 'region'
    }, {
      label: '省级团队',
      value: 'province'
    }, {
      label: '市级团队',
      value: 'city'
    }, {
      label: '区县级团队',
      value: 'district'
    }];
    getCatalog({
      type: 'supplierCategory'
    }).then(data => {
      if (data) {
        teamTypes.value = data;

        if (data.length) {
          form.value.supplierCategory = data[0].value;
        }
      }
    }); // 加载关联项目列表（返回 List<ProjectVo>），支持可选关键词搜索

    function loadProjectOptions() {
      return _loadProjectOptions.apply(this, arguments);
    } // el-select 的远程搜索回调


    function _loadProjectOptions() {
      _loadProjectOptions = _asyncToGenerator(function* (keyword = '') {
        try {
          // 如果还没缓存全部项目，先拉取一次完整列表并缓存
          if (!allProjects.value.length) {
            const res = yield fetch('/admin/common/getProjectList.json');
            const data = yield res.json();
            allProjects.value = Array.isArray(data) ? data : (data === null || data === void 0 ? void 0 : data.rows) || [];
          } // 无关键词则直接显示全部，带关键词则在客户端做过滤


          const k = String(keyword || '').trim().toLowerCase();

          if (!k) {
            projectOptions.value = allProjects.value;
          } else {
            projectOptions.value = allProjects.value.filter(p => String(p.projectName || '').toLowerCase().includes(k));
          }
        } catch (err) {
          console.error('loadProjectOptions error', err);
          projectOptions.value = [];
          allProjects.value = [];
        }
      });
      return _loadProjectOptions.apply(this, arguments);
    }

    function handleProjectSearch(query) {
      loadProjectOptions(query || '');
    }

    const loading = ref(false);
    watch(() => props.modelValue, newVal => {
      var _scroll$value;

      (_scroll$value = scroll.value) === null || _scroll$value === void 0 ? void 0 : _scroll$value.setScrollTop(0);
      if (newVal) loadProjectOptions();

      if (newVal && !props.editData) {
        var _formRef$value;

        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields();
        tableData.value = [];
        cascaderValue.value = [];
      } else if (newVal && props.editData) {
        let {
          supBusiScop,
          supplierName,
          linkMan,
          linkPhone,
          supplierCategory,
          supplierId,
          changeSalemansBranch = '0',
          areaLevel
        } = props.editData;
        changeSalemansBranch = changeSalemansBranch == null ? '0' : changeSalemansBranch;
        form.value = {
          branchIds: '',
          inputBusiScop: supBusiScop.split(','),
          supplierName,
          supplierCategory,
          linkMan,
          linkPhone2: linkPhone,
          changeSalemansBranch,
          areaLevel
        }; // console.log('dictList', props.dictList)
        // console.log('inputBusiScop', supBusiScop)
        // loading.close()

        getEditDistributorList({
          supplierId
        }).then(data => {
          if (data !== null && data !== void 0 && data.rows) {
            // 标记为已持久化：仅当后端返回 teamBranchId 且 projectId 同时存在
            tableData.value = data === null || data === void 0 ? void 0 : data.rows.map(r => _objectSpread(_objectSpread({}, r), {}, {
              _persisted: !!(r.teamBranchId && r.projectId)
            })); // 同步已存在行的 projectName（如果后端只是返回了 projectId）

            syncProjectNames();
          }
        }); // busiScopChangeHandle(supBusiScop.split(','));

        loading.value = true;
        setTimeout(() => {
          let list = [];
          props.dictList.forEach(province => {
            // let areaCodeList = []
            if (supBusiScop.includes(province.id)) {
              if (province.children && province.children.length) {
                province.children.forEach(city => {
                  if (city.children && city.children.length) {
                    city.children.forEach(area => {
                      list.push([province.id, city.id, area.id]);
                    });
                  } else {
                    list.push([province.id, city.id]);
                  }
                });
              } else {
                list.push([province.id]);
              }

              return;
            }

            if (province.children && province.children.length) {
              province.children.forEach(city => {
                if (supBusiScop.includes(city.id)) {
                  if (city.children && city.children.length) {
                    city.children.forEach(area => {
                      list.push([province.id, city.id, area.id]);
                    });
                  } else {
                    list.push([province.id, city.id]);
                  }

                  return;
                }

                if (city.children && city.children.length) {
                  city.children.forEach(area => {
                    if (supBusiScop.includes(area.id)) {
                      list.push([province.id, city.id, area.id]);
                    }
                  });
                }
              });
            }
          }); // console.log(list)

          cascaderValue.value = list;
          loading.value = false;
        }, 500);
      }
    }, {
      flush: 'post'
    }); // 切换团队类型指定团队清空

    watch(() => form.value.supplierCategory, () => {
      tableData.value = [];
      uploadTableColName();
    });

    function addSuccess(rows) {
      // 新增的行标记为未持久化，允许编辑关联项目
      const newRows = rows.map(r => _objectSpread(_objectSpread({}, r), {}, {
        _persisted: false,
        projectId: r.projectId || ''
      }));
      tableData.value = arrayRemoveRepeatByProp([...tableData.value, ...newRows], 'basicBranchId'); // console.log(tableData.value);
    }

    function addManufactorSuccess(rows) {}

    function del() {
      // console.log(table.value);
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      tableData.value = tableData.value.filter(row => !selectRows.find(item => item.branchId === row.branchId));
    } // 将 projectId 映射为 projectName，填充到每一行的 projectName 字段


    function syncProjectNames() {
      if (!tableData.value || !tableData.value.length) return;
      tableData.value.forEach(row => {
        if (row.projectId) {
          const found = projectOptions.value.find(p => String(p.projectId) === String(row.projectId));
          row.projectName = found ? found.projectName : row.projectName || '';
        } else {
          row.projectName = row.projectName || '';
        }
      });
    } // 当 projectOptions 加载完成后，同步已有行的 projectName


    watch(projectOptions, () => {
      syncProjectNames();
    });

    function confirm() {
      cascaderChange();
      let areaList = formatCheckedKeys(props.dictList, []);
      let areaLevelList = Array.from(new Set(areaList.map(v => v.areaLevel)));
      /** if (areaLevelList.length > 1) {
         ElMessage.error('业务区域等级不同')
         return
       } */

      form.value.inputBusiScop = areaList.map(v => v.id);

      if (!tableData.value.length) {
        ElMessage.warning(`请关联${form.value.supplierCategory === 1 ? '厂家' : '发货方'}`);
        return;
      }

      formRef.value.validate(e => {
        if (e) {
          // 判断是否为编辑模式
          if (props.editData) {
            var _props$editData;

            // 编辑模式：直接保存
            // minimal change: append projectId to branchIds as `branchId:projectId`
            const branchIds = tableData.value.map(item => `${item.branchId}:${item.projectId || ''}`).join(',');
            mergeSupplier(_objectSpread(_objectSpread({}, form.value), {}, {
              branchIds,
              inputBusiScop: form.value.inputBusiScop.join(','),
              supplierIdTwo: ((_props$editData = props.editData) === null || _props$editData === void 0 ? void 0 : _props$editData.supplierId) || '',
              __warn: true,
              __repeat: true
            })).then(data => {
              if (data.success) {
                ElMessage.success('保存成功!');
                emit('success');
                visible.value = false;
              }
            });
          } else {
            // 新增模式：显示确认弹框
            ElMessageBox.confirm('请确认团队名称是否正确，保存后不支持修改', '提示', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              var _props$editData2;

              const branchIds = tableData.value.map(item => `${item.branchId}:${item.projectId || ''}`).join(',');
              mergeSupplier(_objectSpread(_objectSpread({}, form.value), {}, {
                branchIds,
                inputBusiScop: form.value.inputBusiScop.join(','),
                supplierIdTwo: ((_props$editData2 = props.editData) === null || _props$editData2 === void 0 ? void 0 : _props$editData2.supplierId) || '',
                __warn: true,
                __repeat: true
              })).then(data => {
                if (data.success) {
                  ElMessage.success('保存成功!');
                  emit('success');
                  visible.value = false;
                }
              });
            }).catch(() => {// 用户点击取消，不执行任何操作
            });
          }
        }
      });
    }

    let columns = [{
      type: 'checkbox',
      width: '50px',
      fixed: 'left'
    }, {
      title: '发货方编号',
      field: 'branchId',
      width: '200px',
      showOverflow: true
    }, {
      title: '发货方名称',
      field: 'branchName',
      width: '150px',
      showOverflow: true
    }, {
      title: '关联项目',
      field: 'projectId',
      width: '200px',
      slots: {
        default: 'projectId'
      },
      showOverflow: true
    }, {
      title: '业务区域',
      field: 'businessArea',
      width: '150px',
      showOverflow: true
    }, {
      title: '详细地址',
      field: 'address',
      width: '250px',
      showOverflow: true
    }, {
      title: '联系人',
      field: 'linkMan',
      width: '200px',
      showOverflow: true
    }, {
      title: '联系人电话',
      field: 'linkTel',
      width: '150px',
      showOverflow: true
    }];

    function uploadTableColName() {
      var _table$value;

      columns.forEach(item => {
        if (item.title) {
          let regText = form.value.supplierCategory !== 1 ? '厂家' : '发货方';
          let replaceText = form.value.supplierCategory === 1 ? '厂家' : '发货方';
          item.title = item.title.replace(regText, replaceText);
        }
      });
      (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.loadColumn(columns);
    }

    const tableOptions = {
      columns,
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      }
    }; // 业务区域选择相关

    const cascader = ref();
    const cascaderProps = {
      multiple: true,
      label: 'text',
      value: 'id',
      emitPath: true,
      checkStrictly: false
    };
    const cascaderValue = ref([]);
    const cascaderValueIds = ref([]);
    const busiScopCheckAll = ref(false);

    function busiScopChangeHandle(valueList) {
      if (valueList.length === props.dictList.length) {
        busiScopCheckAll.value = true;
      } else {
        busiScopCheckAll.value = false;
      }
    }

    function busiScopCheckAllHandle() {
      if (busiScopCheckAll.value) {
        form.value.inputBusiScop = props.dictList.map(v => v.id);
      } else {
        form.value.inputBusiScop = [];
      }
    }

    function cascaderChange(value) {
      // console.log(value)
      cascaderValueIds.value = cascader.value.getCheckedNodes().map(v => {
        return {
          id: v.value,
          areaLevel: v.data.areaLevel
        };
      }); // console.log(cascaderValue.value)
    }

    function formatCheckedKeys(treeList, targetList = []) {
      // let checkedKeys = treeRef.value.getCheckedKeys();
      let checkedKeys = cascaderValueIds.value; // console.log(checkedKeys)

      let list = [...targetList];
      treeList.forEach(item => {
        if (checkedKeys.find(v => v.id === item.id)) {
          list.push({
            id: item.id,
            areaLevel: item.areaLevel
          });
          return;
        }

        if (item.children && item.children.length) {
          list = list.concat(formatCheckedKeys(item.children));
        }
      });
      return list;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_WarningFilled = _resolveComponent("WarningFilled");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_popover = _resolveComponent("el-popover");

      const _component_el_cascader = _resolveComponent("el-cascader");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        title: __props.editData ? '编辑控销团队' : '新建控销团队',
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        })]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
          height: "400px",
          style: {
            "padding": "10px"
          },
          ref_key: "scroll",
          ref: scroll
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            model: form.value,
            ref_key: "formRef",
            ref: formRef,
            "label-width": "80px",
            "label-position": "left"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "团队名称",
                  prop: "supplierName",
                  rules: [{
                    required: true,
                    message: '请输入团队名称'
                  }, {
                    max: 20,
                    min: 4,
                    message: '字符长度为4-20位'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: form.value.supplierName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.supplierName = $event),
                    disabled: false
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "团队类型",
                  prop: "supplierCategory",
                  rules: {
                    required: true,
                    message: '请选择团队类型'
                  }
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_select, {
                    modelValue: form.value.supplierCategory,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.supplierCategory = $event),
                    disabled: !!__props.editData,
                    style: {
                      "width": "250px",
                      "margin-right": "10px"
                    }
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamTypes.value, item => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        label: item.text,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]), _createVNode(_component_el_popover, {
                    trigger: "hover",
                    title: "提示",
                    width: "300px",
                    effect: "dark"
                  }, {
                    reference: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_component_WarningFilled)]),
                      _: 1
                    })]),
                    default: _withCtx(() => [_hoisted_2]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "团队级别",
                  prop: "areaLevel",
                  rules: {
                    required: true,
                    message: '请选择团队级别'
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: form.value.areaLevel,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.areaLevel = $event),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(areaLevels, item => {
                      return _createVNode(_component_el_option, {
                        label: item.label,
                        value: item.value,
                        key: item.value
                      }, null, 8, ["label", "value"]);
                    }), 64))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "业务区域",
                  prop: "inputBusiScop",
                  rules: {
                    required: true,
                    message: '请选择业务区域',
                    trigger: 'submit'
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_cascader, {
                    ref_key: "cascader",
                    ref: cascader,
                    modelValue: cascaderValue.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => cascaderValue.value = $event),
                    options: __props.dictList,
                    props: cascaderProps,
                    showAllLevels: true,
                    size: "default",
                    "collapse-tags": ""
                  }, null, 8, ["modelValue", "options"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "联系人",
                  prop: "linkMan",
                  rules: {
                    required: true,
                    message: '请输入联系人'
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: form.value.linkMan,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.linkMan = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "联系电话",
                  prop: "linkPhone2",
                  rules: [{
                    required: true,
                    message: '请输入联系电话'
                  }, {
                    max: 11,
                    min: 11,
                    message: '手机号为11位数字'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: form.value.linkPhone2,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.linkPhone2 = $event),
                    type: "number"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "是否同步更换业务员分销商",
                  prop: "changeSalemansBranch",
                  "label-width": "200px",
                  required: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                    modelValue: form.value.changeSalemansBranch,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.changeSalemansBranch = $event)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_radio, {
                      label: "0"
                    }, {
                      default: _withCtx(() => [_hoisted_3]),
                      _: 1
                    }), _createVNode(_component_el_radio, {
                      label: "1"
                    }, {
                      default: _withCtx(() => [_hoisted_4]),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"]), _createVNode(_component_vxe_grid, _mergeProps(tableOptions, {
            ref_key: "table",
            ref: table,
            data: tableData.value
          }), {
            tools: _withCtx(() => [form.value.supplierCategory === 1 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              icon: "Plus",
              onClick: _cache[7] || (_cache[7] = $event => showDistributorListModal.value = true)
            }, {
              default: _withCtx(() => [_hoisted_5]),
              _: 1
            })) : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              icon: "Plus",
              onClick: _cache[8] || (_cache[8] = $event => showDistributorListModal.value = true)
            }, {
              default: _withCtx(() => [_hoisted_6]),
              _: 1
            })), _createVNode(_component_el_button, {
              type: "danger",
              icon: "Delete",
              onClick: del
            }, {
              default: _withCtx(() => [_hoisted_7]),
              _: 1
            }), _hoisted_8]),
            projectId: _withCtx(({
              row
            }) => {
              var _projectOptions$value;

              return [row._persisted && row.projectId ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(row.projectName || ((_projectOptions$value = projectOptions.value.find(p => String(p.projectId) === String(row.projectId))) === null || _projectOptions$value === void 0 ? void 0 : _projectOptions$value.projectName) || '无'), 1)) : (_openBlock(), _createBlock(_component_el_select, {
                key: 1,
                modelValue: row.projectId,
                "onUpdate:modelValue": $event => row.projectId = $event,
                filterable: "",
                remote: "",
                "reserve-keyword": "",
                "remote-method": "handleProjectSearch",
                clearable: "",
                placeholder: "请选择",
                style: {
                  "width": "180px"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectOptions.value, p => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: p.projectId,
                    label: p.projectName,
                    value: p.projectId
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"]))];
            }),
            _: 1
          }, 16, ["data"])]),
          _: 1
        })), [[_directive_loading, loading.value]])]),
        _: 1
      }, 8, ["title", "modelValue"]), _createVNode(SelectDistributorListModal, {
        modelValue: showDistributorListModal.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => showDistributorListModal.value = $event),
        dictList: __props.dictList,
        supplierCategory: form.value.supplierCategory,
        onSuccess: addSuccess
      }, null, 8, ["modelValue", "dictList", "supplierCategory"])], 64);
    };
  }

};